import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Page } from 'src/app/models/page.model';
import { CommonService, MessagesService, PageService, SpinnerService } from 'src/app/services/service.index';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { ResourceParameter } from 'src/app/services/microapplications/_models/resource-parameter.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { MainHTTPService } from 'src/app/services/main-http/main-http.service';
import { Link } from 'src/app/models/menu';

@Component({
  selector: 'app-moreaccess',
  templateUrl: './moreaccess.component.html',
  styleUrls: ['./moreaccess.component.scss']
})
export class moreaccessComponent implements OnInit {
  public sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');
  public favoriteListArr: any[] = [];
  public favoriteSelected: any;
  public showOptionsFav: boolean = false;
  public codUser: string;
  pagesSe: Page[] = [];
  pages: Page[] = [];
  Linkdata: Link[] = [];
  private sanitizer: DomSanitizer;
  public listHistorial = JSON.parse(
    sessionStorage.getItem('listHisotrial') || '[]'
  );
  html: SafeResourceUrl;
  url: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>('');
  // url enlace de mas accesos
  public admin = {
    cod_prog: 'admin-process',
    nom_prog: 'Administrador de procesos',
    idForm: 'admin-process',
    nom_fisi: '/formio/admin-process',
    view: true
  };
  @Output() close = new EventEmitter<any>();
  @ViewChild("favoriteIcon") favoriteIcon: any;
  @ViewChild("favoriteBody") favoriteBody: any;
  idDesinger: any;
  urlReport: string;
  token: string;
  user$: any;
  company: any;
  username: any;
  usercode: string;
  canNavigate = false;
  encryptedUrl: any;
  constructor(private config: ConfigService, private mainHTTPService: MainHTTPService, private router: Router, private _commonService: CommonService, private _spinnerService: SpinnerService, private auth: AuthService, private _messagesService: MessagesService, private microapps: MicroapplicationService, private _pageService: PageService) {
    this.codUser = '';
  }


  ngOnInit(): void {

    this.loaddesignmicroapp();
    this.urlReport = this.config.config.urlReportingServices;
    this.user$ = this.auth.currentUserSubject.asObservable();
    this.company = this.sessionData.selectedCompany.code;
    this.username = this.sessionData.username;
    this.usercode = this.sessionData.accountCode;
    this.canNavigate = this.sessionData.roleType === 'D'; //Caso 974888
  }

  generarPage(forma: any, admin = false) {
    const page: Page = {
      codProg: forma.cod_prog,
      name: forma.nom_prog,
      idForm: forma.idForm,
      id: 0,
      url: forma.nom_fisi.toLowerCase(),
      cambiarUrl: true,
      view: forma.hasOwnProperty('view') ? forma.view : false,
      lisnk: this.Linkdata
    }
    !admin ? page.url = page.url + '&cod_prog=' + page.codProg : null
    this._pageService.generarPage(page);
    this.closeEmit();
  }



  deleteFavorite(event: any, forma: any): void {
    this.favoriteSelected = forma;
    event.preventDefault();
    this.showOptionsFav = false;

  }

  addListfavorite(data: any) {
    this.favoriteListArr.push(data)
  }
  closeEmit() {
    this.close.emit(1);
  }
  onItemClick(event: MouseEvent): void {
    this.closeEmit();
    if (!this.canNavigate) {
      event.preventDefault();
      event.stopPropagation();
      this._messagesService.error('Tipo de usuario no autorizado para esta acción');
      return;
    }
  }

  loaddesignmicroapp() {
    this.microapps.GetMicroApplicationsByCodForm(this.config.config.designerCode).subscribe(resp => {

      if (resp.isSuccessful) {

        this.idDesinger = resp.result.id;
      }
    })
  }
  getDataoctober() {

    const sessionData = JSON.parse(sessionStorage.getItem('licen'));
    // if (sessionData == 'V') {   --- se quita restriccion  deacuerdo al caso 1012631
      const datacrypter = "?_session_key=&_token=&login=OC-SEV" + this.sessionData.selectedCompany.code + "&password=" + this.sessionData.selectedCompany.nit + "";
      const encryptionKey = "SevenOctober";
      // this.encryptedUrl = CryptoJS.AES.encrypt(datacrypter, encryptionKey).toString();
      this.encryptedUrl = btoa(datacrypter); // btoa() convierte a Base64
      const urlayudaenlinea = this.config.config.urlAyudaenlinea + "?data=" + this.encryptedUrl + "";

      const url = urlayudaenlinea;
      window.open(url, '_blank');
    // }
    // else {
    //   this._messagesService.error('Su licencia se encuentra vencida o está inactiva, por favor comuníquese con el administrador ');
    // }


  }


  addHistorial(node: any) {

    let index = this.listHistorial.findIndex(
      (e: any) => e.idForm == node.idForm

    );
    if (index != -1) {
      this.listHistorial.splice(index, 1);
      this.listHistorial.push(node);
    } else {
      this.listHistorial.push(node);
    }

    if (this.listHistorial.length > 3) {
      this.listHistorial = this.listHistorial.slice(
        this.listHistorial.length - 3
      );
    }
    sessionStorage.setItem('listHisotrial', JSON.stringify(this.listHistorial));
  }
  getDatareporting() {
    this._spinnerService.loading();
    const page: Page = {
      codProg: "Reporting",
      name: "Reporteador",
      idForm: null,
      id: 453,
      url: null,
      cambiarUrl: true,
      // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
      typeForm: 'maestro',
      lisnk: this.Linkdata,
    };
    this.removeClass('open-item');
    this._spinnerService.close();

    page.url = this.config.config.urlReportingServices;


    this._pageService.generarPage(page);
    this.closeEmit();

  }
  getDataMicroApp(id) {
    this._spinnerService.loading();

    this.microapps.GetMicroApplicationsById(id).subscribe((microApp) => {
      if (microApp.isSuccessful) {
        let url = `${microApp.result.url}?`;
        if (microApp.result.parameters != null) {
          let i = 0;
          for (const parameter of microApp.result.parameters) {

            url += `${i === 0 ? '' : '&'}${parameter.code}=${this.GetGlobalVariables(parameter)}`;
            i += 1;
          }


          const page: Page = {
            codProg: microApp.result.id,
            name: microApp.result.category,
            idForm: microApp.result.code,
            id: microApp.result.id,
            url: null,
            cambiarUrl: true,

            // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
            typeForm: 'maestro',
            lisnk: this.Linkdata
          };
          this.removeClass('open-item');
          this._spinnerService.close();

          page.url = url;

          // this._commonService.setItemsessionStorage('Pages', this.pagesSe);
          // this.router.navigate(['/pageTabPanel']);
          this._pageService.generarPage(page);
          this.closeEmit();
        }
      }
    }, err => {

      this._messagesService.error('Error conectando con servicio de microaplicaciones');
    });
  }

  removeClass = (classs: string) => {
    let nodes = document.querySelectorAll(`.${classs}`);
    nodes.forEach(node => {
      node.classList.remove(classs)
    })
  }

  GetGlobalVariables(param: ResourceParameter) {
    if (param.type == 0) {
      return param.value;
    } else {
      switch (param.code) {
        case "token":
          return this.auth.getAuthFromLocalStorage().accessToken;
        case "companyCode":
          return 1;
      }
    } return null
  }


  getDataagend() {

    this._spinnerService.loading();
    this.mainHTTPService.getFilter("SGNCAAGE").subscribe(resp => {
      if (resp.isSuccessful) {
        // this.main.next(resp.result);
        this.microapps.GetMicroApplicationsById(resp.result[0].microApplicationId).subscribe(resp => {
          if (resp.isSuccessful) {

            this.token = this.auth.getAuthFromLocalStorage().accessToken;
            const page: Page = {
              codProg: "Agenda",
              name: "Agenda",
              idForm: null,
              id: 453,
              url: null,
              cambiarUrl: true,
              // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
              typeForm: 'maestro',
              lisnk: this.Linkdata
            };
            this.removeClass('open-item');
            this._spinnerService.close();

            page.url = resp.result.url + '?companyCode=' + this.company + '&token=' + this.token + '&mode=browser';

            // this._commonService.setItemsessionStorage('Pages', this.pagesSe);
            // this.router.navigate(['/pageTabPanel']);
            this._pageService.generarPage(page);
            // var urlserv = resp.result.url;
            // var fg =resp.result.url + '?companyCode=' + this.company + '&token=' + this.token + ''
            // this.url.next(this.sanitizer.bypassSecurityTrustResourceUrl(resp.result.url + '?companyCode=' + this.company + '&token=' + this.token + '&mode=browser'));
          }
        });
      }
      else { }
    });
  }

  getDataalertpanel() {

    this._spinnerService.loading();
    this.mainHTTPService.getFilter("SGNGEALE").subscribe(resp => {
      if (resp.isSuccessful) {
        // this.main.next(resp.result);
        this.microapps.GetMicroApplicationsById(resp.result[0].microApplicationId).subscribe(resp => {
          if (resp.isSuccessful) {

            this.token = this.auth.getAuthFromLocalStorage().accessToken;
            const page: Page = {
              codProg: "Alertas",
              name: "Alertas",
              idForm: null,
              id: 453,
              url: null,
              cambiarUrl: true,
              // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
              typeForm: 'maestro',
              lisnk: this.Linkdata
            };
            this.removeClass('open-item');
            this._spinnerService.close();

            page.url = resp.result.url + '?companyCode=' + this.company + '&token=' + this.token + '&mode=browser';

            // this._commonService.setItemsessionStorage('Pages', this.pagesSe);
            // this.router.navigate(['/pageTabPanel']);
            this._pageService.generarPage(page);
            // var urlserv = resp.result.url;
            // var fg =resp.result.url + '?companyCode=' + this.company + '&token=' + this.token + ''
            // this.url.next(this.sanitizer.bypassSecurityTrustResourceUrl(resp.result.url + '?companyCode=' + this.company + '&token=' + this.token + '&mode=browser'));
          }
        });
      }
      else { }
    });
  }

  getDataImperium() {

    this._spinnerService.loading();
    const page: Page = {
      codProg: "Imperium",
      name: "Imperium",
      idForm: null,
      id: 444,
      url: null,
      cambiarUrl: true,
      lisnk: this.Linkdata,
      // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
      typeForm: 'maestro',


    };

    // /#/home?user=1212121212&system=SEVEN&type=bearer&name=authorization&value=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfb
    this.token = this.auth.getAuthFromLocalStorage().accessToken;
    const urImperium = this.config.config.urImperium + "/#/home?user=" + this.usercode + "&system=SEVEN&type=bearer&name=authorization&value=" + this.token;

    this.pagesSe.length = 0;
    // alert(urlayudaenlinea)
    this.pagesSe.push({
      codProg: "Imperium",
      name: "Imperium",
      idForm: null,
      id: 444,
      url: urImperium,
      cambiarUrl: true,
      lisnk: this.Linkdata,
      // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
      typeForm: 'maestro',
    })

    // this.removeClass('open-item');


    setTimeout(() => {
      this._spinnerService.close();
    }, 5000);

    page.url = urImperium;

    this._commonService.setItemsessionStorage('Pages', this.pagesSe);
    // this.router.navigate(['/pageTabPanel']);
    // this.addHistorial(page);
    this._pageService.generarPage(page);
    this.closeEmit();

  }
}
